<template>
  <div>
    <video :src="datas.shortVideo" controls></video>
  </div>
</template>

<script>
export default {
  name: 'video',
  data () {
    return {
      datas: JSON.parse(sessionStorage.getItem('videoContent'))
    }
  },
  mounted () {
    console.log(this.$route.meta)
    this.$route.meta.title = this.datas.name
  },
  methods: {
  }
}
</script>

<style scoped>
  video {
    width: 100%;
    height: 94vh;
    background-color: #000;
  }
</style>
